import React from 'react';
import propTypes from 'prop-types';
import { usePoseWithBulma } from 'src/ui/hooks';
import { Form, Field } from 'react-final-form';
;
import { Button, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal } from 'src/ui/mui-ui-kit';;
import {
  FadeInDiv,
  AnimatedCard,
  InnerLoader,
  UiSelectAdapter,
  UiToggleAdapter,
} from 'src/ui';
import { required } from 'src/ui/validations';
import { BG_CHECK_PRODUCTS } from 'src/background-check';

export function BackgroundCheckModal({
  isActive,
  onClickConfirm,
  title,
  onClickCancel,
  bgCheckPackages,
}) {
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );

  return (
    <Form
      onSubmit={onClickConfirm}
      validate={({ productCodes, packageCode }) => {
        if ((packageCode || {}).isCustom) {
          return (
            (productCodes || []).length > 0 ||
            'At least one product must be selected'
          );
        }
        return undefined;
      }}
      render={({
        form,
        hasValidationErrors,
        submitting,
        handleSubmit,
        values,
      }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Modal isActive={isModalVisible} className="background-check-modal">
            <ModalBackground
              tag={FadeInDiv}
              pose={currentPose}
              onPoseComplete={onPoseComplete}
            />
            <ModalCard tag={AnimatedCard} pose={currentPose}>
              <InnerLoader visible={submitting} />
              <ModalCardHeader>
                <ModalCardTitle
                  tag="h5"
                  className="has-text-weight-semibold"
                  hasTextColor="primary"
                >
                  Run Verification for {title}
                </ModalCardTitle>
              </ModalCardHeader>
              <ModalCardBody>
                <Field
                  component={UiSelectAdapter}
                  name="packageCode"
                  id="packageCode"
                  label="Service Package"
                  required
                  validate={required('Service Package')}
                  options={bgCheckPackages}
                  getOptionValue={item => item.code}
                  getOptionLabel={item => item.name}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />

                {values.packageCode &&
                  values.packageCode.isCustom &&
                  BG_CHECK_PRODUCTS.map(product => (
                    <Field
                      key={product.code}
                      component={UiToggleAdapter}
                      name="productCodes[]"
                      id={`product${product.code}`}
                      value={product.code}
                      type="checkbox"
                    >
                      {product.name}
                    </Field>
                  ))}

                <div className="buttons is-centered">
                  <Button
                    hasTextColor="info"
                    onClick={() => onClickCancel(form)}
                  >
                    Cancel
                  </Button>
                  <Button
                    isColor="gradient-bright"
                    type="submit"
                    disabled={hasValidationErrors}
                  >
                    Verify
                  </Button>
                </div>
              </ModalCardBody>
            </ModalCard>
          </Modal>
        </form>
      )}
    />
  );
}

BackgroundCheckModal.propTypes = {
  isActive: propTypes.bool.isRequired,
  onClickConfirm: propTypes.func.isRequired,
  onClickCancel: propTypes.func.isRequired,
  title: propTypes.string.isRequired,
  bgCheckPackages: propTypes.array.isRequired,
};
